import { createContext } from 'react';
const ScrollHelperContext = createContext();
export const ScrollHelperProvider = ScrollHelperContext.Provider;
export default ScrollHelperContext;